import validator from 'validator';

type Validator = (value : any) => boolean;
type Message = (fieldName : string) => string;
export default class ValidatorRule {
    validator: Validator
    message: Message

    constructor(validator : Validator, message : Message) {
        this.validator = validator;
        this.message = message;
    }

    isValid(value : any) {
        return this.validator(value);
    }

    formatMessage(fieldName : string) {
        return this.message(fieldName);
    }
}

export const validateRules = (rules : Array<ValidatorRule>, value : any) : { isValid : boolean, validator? : ValidatorRule }=> {
    for (let i = 0; i < rules.length; i++) {
        const isValid = rules[i].isValid(value);
        if(!isValid) {
            return {
                isValid: false,
                validator: rules[i]
            };
        }
    }
    return {
        isValid: true
    };
};

export const validateRuleMap = (ruleMap : {[key : string] : Array<ValidatorRule>}, valueMap : {[key : string] : any}) : boolean => {
    const keys = Object.keys(ruleMap);
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const rules = ruleMap[key];
        const value = valueMap[key] === null ? '' : valueMap[key].toString() as string;
        const { isValid } = validateRules(rules, value);
        if (!isValid)
            return false;
    }
    return true;
};
   
export const required = new ValidatorRule((value : string) => !validator.isEmpty(value), (value : string) => `This field (${value}) is empty`);
export const isAlpha = new ValidatorRule((value : string) => validator.isAlpha(value), (value : string) => "Please enter a valid name");
export const isEmail = new ValidatorRule((value : string) => validator.isEmail(value), (value : string) => "Please enter a valid email address");
export const isFullName = new ValidatorRule((value : string) => validator.matches(value, "^[a-zA-Z ,.'-]+$"), (value : string) => "Please enter a valid name");
export const isNumeric = new ValidatorRule((value : string) => validator.isNumeric(value), (value : string) => `This field (${value}) should only contain numbers`);
export const isAlphanumeric = new ValidatorRule((value : string) => validator.isAlphanumeric(value), (value : string) => `This field (${value}) should only contain letters and numbers`);
export const isSingleChar = new ValidatorRule((value : string) => validator.isLength(value, { min: 0, max: 1 }), (value : string) => `This field (${value}) should be a single character`);